import { render } from "./buttonTapComponent.vue?vue&type=template&id=7133e0d0"
const script = {}

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__